import { DataItem } from '../../../@types/DataItem';
import { moreFiltersValue, MoreFiltersValue } from '../../../reducers/gerenciadorPrecos/filters/moreFilters';
import { listArchitectureData, listMoreFitersData, listMpdvScopeData, listPriceRulesData } from './service';

export const moreFiltersDataQuery = () => {
  return {
    queryKey: ['ipa.priceManager.moreFiltersData'],
    queryFn: listMoreFitersData,
  } as const;
};

export const moreFiltersRenderQuery = (moreFilters: MoreFiltersValue = moreFiltersValue[0], query = '', selectedValues: string[] = []) => {
  return {
    queryKey: ['ipa.moreFiltersRender', moreFilters, query, selectedValues],
    queryFn: async () => {
      const moreFiltersRenderQueryFnMap = new Map<MoreFiltersValue, (query: string, selectedValues?: string[]) => Promise<DataItem[]>>([
        ['scope', listMpdvScopeData],
        ['ruleIds', listPriceRulesData],
        ['architectureIds', listArchitectureData],
      ]);
      const queryFn = moreFiltersRenderQueryFnMap.get(moreFilters);
      return await queryFn?.(query, selectedValues);
    },
    enabled: !!moreFilters,
  };
};
